import React, { useEffect, useState } from 'react';
import { isEmpty } from 'lodash';

import { getMonthsList, getYearsList } from './utils';

import SimpleReportFilters from 'containers/shared/SimpleReportFilters';

import SelectInput from './selectInput';

import './yearMonthSelection.style.css';
import { Radio, Space } from 'antd';
import { FormattedMessage } from 'react-intl';
import messages from './messages';

const YearMonthSelection = ({ month, year, period, dateChanged, onDayOrDateComparisonChange, dayComparisonValue }) => {
    const yearRangeBefore = 3;
    const yearRangeAfter = 2;

    const [monthSelected, setMonthSelected] = useState(month);
    const [yearSelected, setYearSelected] = useState(year);

    const handleYearChange = ({ value }) => {
        setYearSelected(parseInt(value, 10));
    };

    const handleMonthChange = ({ value }) => {
        setMonthSelected(parseInt(value, 10));
    };

    const handleSubmit = (periodDetails) => {
        if (month && year) {
            dateChanged(monthSelected, yearSelected);
        } else {
            dateChanged(periodDetails);
        }
    };

    const onChangeDayOrDateComparison = (e) => {
        onDayOrDateComparisonChange(e.target.value);
    };

    const monthsList = getMonthsList();
    const yearsList = getYearsList(year, yearRangeBefore, yearRangeAfter);

    useEffect(() => { }, [monthSelected, yearSelected, period, dateChanged]);

    return (
        <div style={{ position: 'sticky', top: 80, zIndex: 998 }}>
            <div className="YearMonthSelectionWrapper">
                <div className="YearMonthSelection">
                    <Space>
                        {!isEmpty(period) && (
                            <div className="periodPicker">
                                <SimpleReportFilters
                                    period={period}
                                    onChangePeriod={handleSubmit}
                                    onSubmit={handleSubmit}
                                    showGetMyDataButton={false}
                                    showTitle={false}
                                    showLabel={false}
                                    maxDateRange={3}
                                />
                            </div>
                        )}
                        {month && year && (
                            <>
                                <div className="YearMonthSelectionItem">
                                    <SelectInput
                                        id="month"
                                        options={monthsList}
                                        className="YearMonthSelectionSelect"
                                        onChange={handleMonthChange}
                                        value={monthSelected}
                                    />
                                </div>
                                <div className="YearMonthSelectionItem">
                                    <SelectInput
                                        id="year"
                                        options={yearsList}
                                        className="YearMonthSelectionSelect"
                                        onChange={handleYearChange}
                                        value={yearSelected}
                                    />
                                </div>
                                <div className="YearMonthSelectionItem">
                                    <button className="YearMonthSelectionButton" onClick={handleSubmit} type="submit">
                                        Update
                                    </button>
                                </div>
                                <div className="YearMonthSelectionItem" />
                                <div className="YearMonthSelectionItem" />
                                <div className="YearMonthSelectionItem" />
                                <div className="YearMonthSelectionItem" />
                                <div className="YearMonthSelectionItem" />
                                <div className="YearMonthSelectionItem" />
                            </>
                        )}
                        {dayComparisonValue !== undefined && dayComparisonValue !== null && (
                            <div className="periodPicker">
                                <Space>
                                    <FormattedMessage {...messages.lastYearComparisonLabel} />
                                    <Radio.Group onChange={onChangeDayOrDateComparison} value={dayComparisonValue} buttonStyle="solid">
                                        <Radio.Button value>
                                            <FormattedMessage {...messages.labelLastYearComparisonByDay} />
                                        </Radio.Button>
                                        <Radio.Button value={false}>
                                            <FormattedMessage {...messages.labelLastYearComparisonByDate} />
                                        </Radio.Button>
                                    </Radio.Group>
                                </Space>
                            </div>
                        )}
                    </Space>
                </div>
            </div>
        </div>
    );
};

export default YearMonthSelection;
